/* eslint-disable no-unused-vars */
import { useContext, useState, useEffect } from "react";
import { SettingsContext } from "../context";
import AccordionItem from "./AccordionItem";
import axios from "axios";
import { Button, Table } from "semantic-ui-react";
import Select from "react-select";

const initialRules = [
  { label: "Triplanar", value: "0" },
  { label: "UV", value: "1" },
];

function MaterialRule({ materialPart, partIndex, materialsPart }) {
  const { editorProductInfo, authenticationToken } =
    useContext(SettingsContext);
  const [materials, setMaterials] = useState([]);
  const [materialRules, setMaterialRules] = useState(initialRules);
  const [mappingTypes] = useState(initialRules);
  const [mappingType, setMappingType] = useState();

  useEffect(() => {
    getMaterialsByProduct();
  }, []);

  const getMaterialsByProduct = async () => {
    if (!editorProductInfo.id) return;

    let url =
      process.env.REACT_APP_BACKEND_API +
      "material/byProduct/" +
      editorProductInfo.id;
    axios
      .get(url, {
        headers: {
          Authorization: authenticationToken,
        },
      })
      .then((res) => {
        setMaterials([]);
        res.data.map((mtl) => {
          setMaterials((prevValues) => {
            return [...prevValues, { value: mtl.id, label: mtl.name }];
          });
        });
      });
  };

  const handleRemove = (partIndex, ruleIndex, e) => {
    removeRules(
      materialsPart[partIndex].ruleList[ruleIndex].material.id,
      materialsPart[partIndex].id
    );
  };

  const removeRules = (materialId, productPartId) => {
    document.dispatchEvent(
      new CustomEvent("open-editor-popup", { detail: "Rule siliniyor" })
    );

    let formData = new FormData();
    formData.append("materialId", materialId);
    formData.append("productPartId", productPartId);

    axios({
      method: "post",
      url: process.env.REACT_APP_BACKEND_API + `material/delete/partAndRules`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authenticationToken,
      },
    }).then(
      (res) => {
        document.dispatchEvent(
          new CustomEvent("update-editor-popup", {
            detail: "Material Part Rule Silindi..",
          })
        );

        document.dispatchEvent(new CustomEvent("close-editor-popup"));
      },
      (rej) => {
        document.dispatchEvent(
          new CustomEvent("update-editor-popup", {
            detail: "Material Part Rule Silinirken hata oluştu...",
          })
        );

        document.dispatchEvent(new CustomEvent("close-editor-popup"));
      }
    );
  };

  const handleRulesMaterial = (e) => {
    let newRules = [];
    e.map((rule) => {
      newRules.push(rule.value);
    });
    setMaterialRules(newRules);
  };

  const updateMaterialPartRules = (partIndex, material) => {
    let selectedMaterialPart = materialsPart[partIndex];

    let rule = {
      productPart: selectedMaterialPart,
      material: {
        id: material.id,
      },
      mappingType: mappingType,
    };

    document.dispatchEvent(
      new CustomEvent("open-editor-popup", {
        detail: "Material Rules Güncelleniyor",
      })
    );

    axios
      .post(
        process.env.REACT_APP_BACKEND_API + `material/update/partRule`,
        rule,
        {
          headers: {
            Authorization: authenticationToken,
          },
        }
      )
      .then(
        (res) => {
          document.dispatchEvent(
            new CustomEvent("update-editor-popup", {
              detail: "Material Rules Güncellendi...",
            })
          );

          document.dispatchEvent(new CustomEvent("close-editor-popup"));
        },
        (rej) => {
          document.dispatchEvent(
            new CustomEvent("update-editor-popup", {
              detail: "Material Rules Güncellenirken hata oluştu.",
            })
          );

          document.dispatchEvent(new CustomEvent("close-editor-popup"));
        }
      );
  };

  const addMaterialPartRules = (partIndex) => {
    let materialPart = materialsPart[partIndex];
    let rulesInfo = [];

    materialRules.map((mtl) => {
      let rule = {
        productPart: materialPart,
        material: {
          id: mtl,
        },
        mappingType: mappingType,
      };
      rulesInfo.push(rule);
    });
    saveMaterialPartRules(rulesInfo);
  };

  const saveMaterialPartRules = (rulesInfo) => {
    document.dispatchEvent(
      new CustomEvent("open-editor-popup", {
        detail: "Material Rules Ekleniyor",
      })
    );

    axios
      .post(
        process.env.REACT_APP_BACKEND_API + `material/add/partRule`,
        rulesInfo,
        {
          headers: {
            Authorization: authenticationToken,
          },
        }
      )
      .then(
        (res) => {
          getMaterialsByProduct();
          document.dispatchEvent(
            new CustomEvent("update-editor-popup", {
              detail: "Material Rules Eklendi...",
            })
          );

          document.dispatchEvent(new CustomEvent("close-editor-popup"));
        },
        (rej) => {
          document.dispatchEvent(
            new CustomEvent("update-editor-popup", {
              detail: "Material Rules Eklenirken hata oluştu...",
            })
          );

          document.dispatchEvent(new CustomEvent("close-editor-popup"));
        }
      );
  };

  return (
    <div>
      <AccordionItem header={materialPart.name + " Rules"}>
        <br />
        <Table singleLine>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Material </Table.HeaderCell>
              <Table.HeaderCell>Rule</Table.HeaderCell>
              <Table.HeaderCell>Action</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {materialPart?.ruleList?.map((rule, ruleIndex) => {
              return (
                <Table.Row key={ruleIndex}>
                  <Table.Cell>{rule.material.name}</Table.Cell>
                  <Table.Cell>
                    <div
                      style={{ width: "100%", margin: "5px", color: "black" }}
                    >
                      <Select
                        menuPosition="fixed"
                        selection
                        defaultValue={
                          initialRules.filter(
                            (b) => b.value == rule.mappingType
                          )[0]
                        }
                        onChange={(e) => {
                          setMappingType(e.value);
                        }}
                        options={mappingTypes}
                        placeholder="Select Rules"
                      />
                    </div>
                  </Table.Cell>
                  <Table.Cell>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <button
                        className="removeButton"
                        style={{ margin: "5px" }}
                        onClick={() => handleRemove(partIndex, ruleIndex)}
                      >
                        Remove
                      </button>
                      <button
                        className="saveButton"
                        onClick={() =>
                          updateMaterialPartRules(partIndex, rule.material)
                        }
                        size="mini"
                      >
                        Update
                      </button>
                    </div>
                  </Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
        <div className="accordion">
          <div style={{ width: "100%", margin: "5px", color: "black" }}>
            <Select
              menuPosition="fixed"
              selection
              onChange={(e) => {
                setMappingType(e.value);
              }}
              options={mappingTypes}
              placeholder="Select Rules"
            />
          </div>
          <div style={{ width: "100%", margin: "5px", color: "black" }}>
            <Select
              menuPosition="fixed"
              isSearchable
              isClearable
              selection
              onChange={(e) => {
                handleRulesMaterial(e);
              }}
              options={materials}
              isMulti={true}
              placeholder="Select Materials"
            />
          </div>
          <button
            className="saveButton"
            onClick={() => addMaterialPartRules(partIndex)}
          >
            Add Rules
          </button>
          <br />
        </div>
      </AccordionItem>
    </div>
  );
}
export default MaterialRule;
